import React from "react";
import logo from '../../assets/logoblack.png'
import { Link } from "react-router-dom";



export default function Terms() {
  return (
    <div className="contenedor_joinus">
    <nav className="navbar navbar-light mb-5" id="encabezado">
              <Link to="/" className="container-fluid">
                  <img
                  src={logo}
                  width="290"
                  height="550"
                  className="img-fluid d-block mx-auto"
                  alt='logoMingga'
                  />
              </Link>
          </nav>

            <div className="container-fluid">
            <div className="privacy" align="left" id="padding">
            <h3 align="center"><b>POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES</b></h3>
                <br />
                <p><b>USO Y APLICACIÓN</b></p>
                <p> 
                La presente Política de Tratamiento de Datos Personales es expedida por  la Editorial Educativa Bibliocol SAS, con sigla BIBLIOCOL, empresa con Matrícula Mercantil No.03124536 de la Cámara de Comercio de Bogotá  del 10 de junio de 2019 y NIT 901.292.437-5. Se aplica en especial a las empresas y organizaciones sociales debidamente constituidas, y a las personas naturales mayores de 14 años que se registren y sean aceptadas como socias de LEO Club Mundial de Lectura, a través del portal web www.clubleo.net.
                </p>
                <p> <b>1. Principios generales y postulados.</b> </p>
                <p>
                BIBLIOCOL, garantiza la protección de derechos como el Habeas Data, la privacidad, la intimidad, el buen nombre, la imagen y la autonomía de las personas naturales y jurídicas; con tal propósito todas las actuaciones se regirán por principios de buena fe, legalidad, autodeterminación informática, libertad y transparencia. <br />
                Quien en ejercicio de cualquier actividad, incluyendo las societarias, comerciales y laborales, sean estas permanentes u ocasionales pueda suministrar cualquier tipo de información o dato personal a BIBLIOCOL y en la cual esta actúe como encargada del tratamiento o responsable del tratamiento podrá conocerla, actualizarla y rectificarla. 
                </p>
                <p><b>2. Marco legal </b></p>
                <p>
                •	Decreto 886 de 2014  <br />
                •	Ley 1266 de 2008 <br />
                •	Ley 1581 de 2012 <br />
                •	Decreto 1377 de 2013 
                </p>
                <p><b>3. Definiciones </b></p>
                <p>
                De conformidad con la legislación vigente sobre la materia, se establecen las siguientes definiciones, las cuales serán aplicadas e implementadas acogiendo los criterios de interpretación que garanticen una aplicación sistemática e integral, y en consonancia con los avances tecnológicos, la neutralidad tecnológica; y los demás principios y postulados que rigen los derechos fundamentales que circundan, orbitan y rodean el derecho de habeas data y protección de datos personales. <br />

                Autorización: Consentimiento previo, expreso e informado del titular para llevar a cabo el Tratamiento de datos personales. <br />

                Base de datos: Conjunto organizado de datos personales que sea objeto de Tratamiento. <br />

                Dato personal: Cualquier información vinculada o que pueda asociarse a una o varias personas naturales determinadas o determinables. <br />

                Encargado del tratamiento: Persona natural o jurídica, pública o privada, que por sí misma o en asocio con otros, realice el tratamiento de datos personales por cuenta del responsable del tratamiento. <br />

                Responsable del tratamiento: Persona natural o jurídica, pública o privada, que por sí misma o en asocio con otros, decida sobre la base de datos y/o el tratamiento de los datos. <br />

                Titular: Persona natural cuyos datos personales sean objeto de tratamiento. <br />

                Tratamiento: Cualquier operación o conjunto de operaciones sobre datos personales, tales como la recolección, almacenamiento, uso, circulación o supresión. 

                </p>
                <p><b>4. Principios específicos  </b></p>
                <p>
                BIBLIOCOL aplicará los principios específicos que se establecen a continuación, los cuales constituyen las reglas a seguir en la recolección, manejo, uso, tratamiento, almacenamiento e intercambio, de datos personales: <br />

                a. Principio de legalidad: En el uso, captura, recolección y tratamiento de datos personales, se dará aplicación a las disposiciones vigentes y aplicables que rigen el tratamiento de datos personales y demás derechos fundamentales conexos.<br />

                b. Principio de libertad: El uso, captura, recolección y tratamiento de datos personales sólo puede llevarse a cabo con el consentimiento, previo, expreso e informado del Titular. Los datos personales no podrán ser obtenidos o divulgados sin previa autorización, o en ausencia de mandato legal, estatutario, o judicial que releve el consentimiento. <br />

                c. Principio de finalidad: El uso, captura, recolección y tratamiento de datos personales a los que tenga acceso y sean acopiados y recogidos por BIBLIOCOL, estarán subordinados y atenderán una finalidad legítima, la cual debe serle informada al respectivo titular de los datos personales.<br />

                d. Principio de veracidad o calidad: La información sujeta a uso, captura, recolección y tratamiento de datos personales debe ser veraz, completa, exacta, actualizada, comprobable y comprensible. Se prohíbe el Tratamiento de datos parciales, incompletos, fraccionados o que induzcan a error. <br />

                e. Principio de transparencia: En el uso, captura, recolección y tratamiento de datos personales debe garantizarse el derecho del Titular a obtener de BIBLIOCOL, en cualquier momento y sin restricciones, información acerca de la existencia de cualquier tipo de información o dato personal que sea de su interés o titularidad. <br />

                f. Principio de acceso y circulación restringida: Los datos personales, salvo la información pública, no podrán estar disponibles en Internet u otros medios de divulgación o comunicación masiva, salvo que el acceso sea técnicamente controlable para brindar un conocimiento restringido sólo a los Titulares. <br />

                g. Principio de seguridad: Los datos personales e información usada, capturada, recolectada y sujeta a tratamiento por BIBLIOCOL, será objeto de protección en la medida en que los recursos técnicos y estándares mínimos así lo permitan, a través de la adopción de medidas tecnológicas de protección, protocolos, y todo tipo de medidas administrativas que sean necesarias para otorgar seguridad a los registros y repositorios electrónicos evitando su adulteración, modificación, pérdida, consulta, y en general en contra de cualquier uso o acceso no autorizado. <br />

                h. Principio de confidencialidad: Todas y cada una de las personas que administran, manejen, actualicen o tengan acceso a informaciones de cualquier tipo que se encuentre en Bases o Bancos de Datos, se comprometen a conservar y mantener de manera estrictamente confidencial y no revelarla a terceros, todas las informaciones personales, comerciales, contables, técnicas, comerciales o de cualquier otro tipo suministradas en la ejecución y ejercicio de sus funciones. Todas las personas que trabajen actualmente o sean vinculadas a futuro para tal efecto, en la administración y manejo de bases de datos, deberán suscribir un documento adicional u otrosí a su contrato laboral o de prestación de servicios para efectos de asegurar tal compromiso. <br />

                Esta obligación persiste y se mantiene inclusive después de finalizada su relación con alguna de las labores que comprende el Tratamiento. 

                </p>
                <p><b>5. Dato sensible   </b></p>
                <p>
                Se entiende por datos sensibles aquellos que afectan la intimidad del titular o cuyo uso indebido puede generar su discriminación, tales como aquellos que revelen el origen racial o étnico, la orientación política, las convicciones religiosas o filosóficas, la pertenencia a sindicatos, organizaciones sociales, de derechos humanos o que promueva intereses de cualquier partido político o que garanticen los derechos y garantías de partidos políticos de oposición así como los datos relativos a la salud, a la vida sexual y los datos biométricos, entre otros, la captura de imagen fija o en movimiento, huellas digitales, fotografías, iris, reconocimiento de voz, facial o de palma de mano, etc. 
                </p>
                <p><b>5.1. Tratamiento de datos sensibles </b></p>
                <p>
                Se podrá hacer uso y tratamiento de los datos catalogados como sensibles cuando: <br />

                a. El Titular haya dado su autorización explícita a dicho tratamiento, salvo en los casos que por ley no sea requerido el otorgamiento de dicha autorización. 

                b. El Tratamiento sea necesario para salvaguardar el interés vital del titular y este se encuentre física o jurídicamente incapacitado. En estos eventos, los representantes legales deberán otorgar su autorización. 

                c. El Tratamiento sea efectuado en el curso de las actividades legítimas y con las debidas garantías por parte de una fundación, ONG, asociación o cualquier otro organismo sin ánimo de lucro, cuya finalidad sea política, filosófica, religiosa o sindical, siempre que se refieran exclusivamente a sus miembros o a las personas que mantengan contactos regulares por razón de su finalidad. En estos eventos, los datos no se podrán suministrar a terceros sin la autorización del titular. 

                d. El Tratamiento se refiera a datos que sean necesarios para el reconocimiento, ejercicio o defensa de un derecho en un proceso judicial.  

                e. El Tratamiento tenga una finalidad histórica, estadística o científica. En este evento deberán adoptarse las medidas conducentes a la supresión de identidad de los Titulares.   

                </p>


                <p><b>5.2.  Autorización del titular   </b></p>
                <p>
                Sin perjuicio de las excepciones previstas en la ley, en el tratamiento se requiere la autorización previa, expresa e informada del titular, la cual deberá ser obtenida por cualquier medio que pueda ser objeto de consulta y verificación posterior. 
                </p>


                <p><b>5.3.  Casos en que no se requiere la autorización </b></p>
                <p>
                La autorización del Titular no será necesaria cuando se trate de: <br />

                a. Información requerida por una entidad pública o administrativa en ejercicio de sus funciones legales o por orden judicial. <br />
                b. Datos de naturaleza pública. <br />
                c. Casos de urgencia médica o sanitaria. <br />
                d. Tratamiento de información autorizado por la ley para fines históricos, estadísticos o científicos. <br />
                e. Datos relacionados con el Registro Civil de las Personas. 

                </p>


                <p><b>6. Derechos de los niños, niñas y adolescentes.   </b></p>
                <p>
                En el Tratamiento se asegurará el respeto a los derechos prevalentes de los menores. <br />

                Queda proscrito el Tratamiento de datos personales de menores, salvo aquellos datos que sean de naturaleza pública. Igualmente, cuando en ejercicio del derecho de asociación consagrado en la Constitución y las Leyes, los menores de edad con edades entre 14 y 18 años, se asocien a LEO Club Mundial de Lectura con autorización y tutoría de su representante legal o tutores, quien velará por el respecto y prevalencia de los derechos del menor. <br />

                Es tarea del Estado y las entidades educativas de todo tipo proveer información y capacitar a los representantes legales y tutores sobre los eventuales riesgos a los que se enfrentan los menores respecto del tratamiento indebido de sus datos personales, y proveer de conocimiento acerca del uso responsable y seguro por parte de niños, niñas y adolescentes de sus datos personales, su derecho a la privacidad y protección de su información personal y la de los demás. 


                </p>

                <p><b>7. Autorizaciones y consentimiento.  </b></p>
                <p>
                La recolección, almacenamiento, uso, circulación o supresión de datos personales por parte de BIBLIOCOL, requiere del consentimiento libre, previo, expreso e informado del titular de los mismos. 
                </p>


                <p><b>7.1. Medio y manifestaciones para otorgar la autorización.   </b></p>
                <p>
                La autorización puede constar en un documento físico, electrónico, mensaje de datos, Internet, Sitios Web, en cualquier otro formato que permita garantizar su posterior consulta, o mediante un mecanismo técnico o tecnológico idóneo, que permita manifestar u obtener el consentimiento vía clic o doble clic, mediante el cual se pueda concluir de manera inequívoca, que de no haberse surtido una conducta del titular, los datos nunca hubieren sido capturados y almacenados en la base de datos. La autorización será generada por BIBLIOCOL y será puesto a disposición del titular con antelación y de manera previa al tratamiento de sus datos personales. 
                </p>

            


                <p><b>7.2. Prueba de la autorización.   </b></p>

                <p>
                BIBLIOCOL utilizará los mecanismos con que cuenta actualmente, e implementará y adoptará las acciones tendientes y necesarias para mantener registros o mecanismos técnicos o tecnológicos idóneos de cuándo y cómo obtuvo autorización por parte de los titulares de datos personales para el tratamiento de los mismos. Para dar cumplimiento a lo anterior, se podrán establecer archivos físicos o repositorios electrónicos realizados de manera directa o a través de terceros contratados para tal fin.
                </p>
                <p>
                Bogotá, D.C. Febrero 19 de 2024.
                </p>

                    
            </div>
            </div>

                
                

              




            
      
           
              

              
     <br />


              
             
    </div>
  );
}
